import React, { useMemo } from 'react';
import styles from '../../styles/case-study-modal.module.scss';
import { trackGoal } from '../../analytics/metrika';

const FALLBACK_TASK = 'Нужно было быстро запустить понятный сайт под заявки без лишних согласований и затяжных доработок.';

const FALLBACK_RESULT = 'Проект передан в запуск в срок, с готовыми CTA и сценариями получения обращений.';

const normalizePoint = (text) => {
  const compact = text
    .replace(/\s+/g, ' ')
    .replace(/^[-•\d.)\s]+/g, '')
    .trim();

  if (!compact) {
    return '';
  }

  const value = compact.charAt(0).toUpperCase() + compact.slice(1);
  return /[.!?]$/.test(value) ? value : `${value}.`;
};

const MetaIcon = ({ type }) => {
  if (type === 'calendar') {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M6 1.8a1 1 0 0 1 1 1V4h6V2.8a1 1 0 1 1 2 0V4h.5A2.5 2.5 0 0 1 18 6.5v9A2.5 2.5 0 0 1 15.5 18h-11A2.5 2.5 0 0 1 2 15.5v-9A2.5 2.5 0 0 1 4.5 4H5V2.8a1 1 0 0 1 1-1m8.5 6.2h-9a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2" />
      </svg>
    );
  }

  if (type === 'wallet') {
    return (
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M4 4a2.5 2.5 0 0 0-2.5 2.5v7A2.5 2.5 0 0 0 4 16h12a2.5 2.5 0 0 0 2.5-2.5v-1.7a2 2 0 0 0-1.4-3.8H15V7.5A2.5 2.5 0 0 0 12.5 5H4zm10 4h3a1 1 0 1 1 0 2h-3a1 1 0 1 1 0-2" />
      </svg>
    );
  }

  if (type === 'telegram') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.66 3.34a2 2 0 0 0-2.06-.42L3.4 8.4a2 2 0 0 0 .11 3.8l3.54 1.02l1.4 4.18a2 2 0 0 0 3.56.45l2.2-2.95l3.2 2.34a2 2 0 0 0 3.13-1.22l2.3-10.68a2 2 0 0 0-.82-2M9.1 12.62l8.47-5.49l-6.87 7.03l-.4 2.03z" />
      </svg>
    );
  }

  if (type === 'externalLink') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M0 0h24v24H0z" fill="none" />
        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4m-8-2l8-8m0 0v5m0-5h-5" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 20 20" aria-hidden="true">
      <path d="M10 1.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 0 0 0-17m0 3a5.5 5.5 0 1 1 0 11a5.5 5.5 0 0 1 0-11" />
    </svg>
  );
};

const SectionIcon = ({ type }) => {
  if (type === 'task') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
          <path d="M14.496 2h-5a1.5 1.5 0 0 0 0 3h5a1.5 1.5 0 0 0 0-3m-6.5 13h3.429m-3.429-4h8" />
          <path d="M15.996 3.5c1.554.047 2.48.22 3.121.862c.88.878.88 2.293.88 5.12V16c0 2.828 0 4.242-.88 5.121c-.878.879-2.293.879-5.12.879h-4c-2.83 0-4.244 0-5.122-.879S3.996 18.828 3.996 16V9.483c0-2.828 0-4.243.879-5.121c.641-.642 1.568-.815 3.121-.862" />
        </g>
      </svg>
    );
  }

  if (type === 'benefits') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 48 48" aria-hidden="true">
        <path
          fill="currentColor"
          d="M27.75 4A4.25 4.25 0 0 1 32 8.25V11h5.75A6.25 6.25 0 0 1 44 17.25v17.5A6.25 6.25 0 0 1 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-17.5A6.25 6.25 0 0 1 10.25 11H16V8.25A4.25 4.25 0 0 1 20.25 4zM41.5 24.75A6.22 6.22 0 0 1 37.75 26H28v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h-9.75a6.22 6.22 0 0 1-3.75-1.25v10a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75zM10.25 13.5a3.75 3.75 0 0 0-3.75 3.75v2.5a3.75 3.75 0 0 0 3.75 3.75H20V23a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v.5h9.75a3.75 3.75 0 0 0 3.75-3.75v-2.5a3.75 3.75 0 0 0-3.75-3.75zm10-7a1.75 1.75 0 0 0-1.75 1.75V11h11V8.25a1.75 1.75 0 0 0-1.75-1.75z"
        />
      </svg>
    );
  }

  if (type === 'fit') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
        <g fill="none">
          <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
          <path
            fill="currentColor"
            d="M9.107 5.448c.598-1.75 3.016-1.803 3.725-.159l.06.16l.807 2.36a4 4 0 0 0 2.276 2.411l.217.081l2.36.806c1.75.598 1.803 3.016.16 3.725l-.16.06l-2.36.807a4 4 0 0 0-2.412 2.276l-.081.216l-.806 2.361c-.598 1.75-3.016 1.803-3.724.16l-.062-.16l-.806-2.36a4 4 0 0 0-2.276-2.412l-.216-.081l-2.36-.806c-1.751-.598-1.804-3.016-.16-3.724l.16-.062l2.36-.806A4 4 0 0 0 8.22 8.025l.081-.216zM11 6.094l-.806 2.36a6 6 0 0 1-3.49 3.649l-.25.091l-2.36.806l2.36.806a6 6 0 0 1 3.649 3.49l.091.25l.806 2.36l.806-2.36a6 6 0 0 1 3.49-3.649l.25-.09l2.36-.807l-2.36-.806a6 6 0 0 1-3.649-3.49l-.09-.25zM19 2a1 1 0 0 1 .898.56l.048.117l.35 1.026l1.027.35a1 1 0 0 1 .118 1.845l-.118.048l-1.026.35l-.35 1.027a1 1 0 0 1-1.845.117l-.048-.117l-.35-1.026l-1.027-.35a1 1 0 0 1-.118-1.845l.118-.048l1.026-.35l.35-1.027A1 1 0 0 1 19 2"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12l6 6L20 6" />
    </svg>
  );
};

const Section = ({ title, iconType, children }) => (
  <section className={styles.section}>
    <h4>
      <span className={styles.sectionIcon}>
        <SectionIcon type={iconType} />
      </span>
      {title}
    </h4>
    <div className={styles.sectionContent}>{children}</div>
  </section>
);

/**
 * @param {{
 * caseData?: {
 * title?: string,
 * serviceType?: string,
 * timeline?: string,
 * priceFrom?: string,
 * priceRange?: string,
 * problem?: string,
 * solution?: string | string[],
 * deliverables?: string[],
 * result?: string,
 * resultMetric?: string,
 * tags?: string[],
 * link?: string,
 * niche?: string
 * } | null,
 * onTelegramClick: () => void
 * }} props
 */
export default function CaseStudyInfoPanel({ caseData, onTelegramClick }) {
  const benefits = useMemo(() => {
    return (caseData?.deliverables || [])
      .map(normalizePoint)
      .filter(Boolean)
      .filter((item, index, list) => list.indexOf(item) === index)
      .slice(0, 5);
  }, [caseData?.deliverables]);

  const hasSiteLink = Boolean(caseData?.link?.trim());

  const openSite = () => {
    if (hasSiteLink) {
      trackGoal('case_site_open', {
        caseId: caseData?.id || 'unknown',
        caseTitle: caseData?.title || 'unknown',
        link: caseData?.link || '',
      });

      window.open(caseData.link, '_blank', 'noopener,noreferrer');
      return;
    }

    onTelegramClick();
  };

  return (
    <aside className={styles.infoPanel}>
      <div className={styles.sections}>
        <Section title="Задача" iconType="task">
          <p>{normalizePoint(caseData?.problem || FALLBACK_TASK)}</p>
        </Section>

        <Section title="Что получает клиент" iconType="benefits">
          <ul>
            {benefits.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </Section>

        <Section title="Результат" iconType="result">
          <p>{normalizePoint(caseData?.result || FALLBACK_RESULT)}</p>
          {caseData?.resultMetric ? <div className={styles.resultMetric}>{normalizePoint(caseData.resultMetric)}</div> : null}
        </Section>
        {/* 
        <Section title="Кому подойдет" iconType="fit">
          <ul>
            {fitPoints.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </Section> */}
      </div>

      {/* <div className={styles.priceCard}>
        <div className={styles.priceTitle}>
          <MetaIcon type="wallet" />
          Бюджет похожего проекта
        </div>
        <div className={styles.priceValue}>{priceLabel}</div>
        <p>Точная стоимость зависит от объема страниц, интеграций и срока запуска.</p>
      </div> */}

      <div className={styles.ctaStack}>
        <button
          type="button"
          className={styles.primaryButton}
          onClick={onTelegramClick}
          aria-label="Обсудить проект в Telegram"
          data-metrika-label="Обсудить в Telegram"
          data-metrika-section="case-modal">
          Обсудить в Telegram
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"
            />
          </svg>
        </button>
        <button
          type="button"
          className={styles.secondaryButton}
          onClick={openSite}
          aria-label={hasSiteLink ? 'Открыть сайт проекта' : 'Запросить демо кейса в Telegram'}
          data-metrika-label={hasSiteLink ? 'Открыть сайт' : 'Запросить демо кейса'}
          data-metrika-section="case-modal">
          {hasSiteLink ? 'Открыть сайт' : 'Запросить демо кейса'}
          {hasSiteLink ? <MetaIcon type="externalLink" /> : null}
        </button>
      </div>
    </aside>
  );
}
